<template>
  <el-dialog
    :title="$t('newApp.Attribute.dcoa')"
    :visible.sync="dialogVisible"
    width="1000px"
    class="activityCostDialog"
    @close="dialogCloseHandle"
  >
    <div class="row">
      <span class="label">{{$t('newApp.Attribute.tp')}}：</span>
      <span class="val cost">{{ rowData.activityCost }}</span>
    </div>
    <commonTable ref="activityCostDialogTable" style="margin: 10px 0" />
    <div class="row" v-if="rowData.expenseDetailNote">
      <div class="label">{{$t('general.Remarks')}}：</div>
      <div class="val">{{ rowData.expenseDetailNote }}</div>
    </div>
  </el-dialog>
</template>

<script>
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
export default {
  data () {
    return {
      dialogVisible: false
    };
  },
  props: {
    activityDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  watch: {
    activityDialogVisible (val) {
      if (val) {
        this.loadTable(this.rowData.activityExpenseDetails);
      }
      this.dialogVisible = val;
    }
  },
  components: {
    commonTable
  },
  methods: {
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    loadTable (data) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.Attribute.pc'))
          ._data('content')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.Attribute.pup'))
          ._data('price')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.Attribute.nop'))
          ._data('amount')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.Attribute.sp'))
          ._data('total')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityCostDialogTable.setColumn(column, {
          page: false
        });
        this.$refs.activityCostDialogTable.loadStaticTable(data);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.activityCostDialog{
  .row{
    position: relative;
    line-height: 17px;
    color: #424C57;
    .cost{
      color: #14937B;
    }
  }
}
</style>
